/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuItem,
  MenuButton,
  SubMenu,
  useMenuState,
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import './style.css';
import { Input, Spinner } from 'reactstrap';
import { BsChevronDown, BsChevronUp, BsPlus } from 'react-icons/bs';
import axios from 'axios';

import { useSettingsDrawer } from 'hooks/useSettingsDrawer';
import { authContext } from 'contexts/AuthContext';
import { TRADER_TYPES } from 'pages/Vendor/constants';

import useCommissionData from '../../../../hooks/useFetchIndianCommission';

const CommissionTypeSelector = ({ id, rowData, type }) => {
  const { openDrawerWithTab } = useSettingsDrawer();
  const { auth } = useContext(authContext);
  const { data: commissionData } = useCommissionData(auth, type);

  const [selectedType, setSelectedType] = useState('Select');
  const [updatingOptionId, setUpdatingOptionId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [menuState, toggleMenu] = useMenuState({ transition: true });
  const isMobileView =
    typeof window !== 'undefined' && window.innerWidth <= 767;

  // Update selected type when data and rowData are available
  useEffect(() => {
    if (commissionData && rowData && type) {
      if (type === TRADER_TYPES.BUYER && rowData.buyerCommissionSlab) {
        const matchingOption = commissionData.data?.find(
          (option) =>
            String(option.id) === String(rowData.buyerCommissionSlab.id),
        );
        setSelectedType(
          matchingOption ? matchingOption.commissionTypeName : 'Default',
        );
      } else if (type !== TRADER_TYPES.BUYER && rowData.sellerCommissionSlab) {
        const matchingOption = commissionData.data?.find(
          (option) =>
            String(option.id) === String(rowData.sellerCommissionSlab.id),
        );
        setSelectedType(
          matchingOption ? matchingOption.commissionTypeName : 'Default',
        );
      } else if (commissionData?.data?.length) {
        setSelectedType(commissionData.data[0].commissionTypeName);
      }
    } else if (commissionData?.data?.length) {
      setSelectedType(commissionData.data[0].commissionTypeName);
    }
  }, [commissionData, rowData, type]);

  const renderCommissionDetails = (option) => {
    const hasData = option && option.minWeight !== undefined;
    const fallback = 'N/A';
    const format = (num) => num?.toLocaleString() ?? fallback;

    const lowerRange = hasData ? `< ${format(option.minWeight)}` : fallback;
    const midRange =
      hasData && option.maxWeight
        ? `${format(option.minWeight)} - ${format(option.maxWeight)}`
        : fallback;
    const upperRange =
      hasData && option.maxWeight ? `> ${format(option.maxWeight)}` : fallback;

    const leastRate =
      hasData && option.leastRangeRate !== undefined
        ? `₹ ${option.leastRangeRate}`
        : fallback;
    const midRate =
      hasData && option.midRangeRate !== undefined
        ? `₹ ${option.midRangeRate}`
        : fallback;
    const maxRate =
      hasData && option.maxRangeRate !== undefined
        ? `₹ ${option.maxRangeRate}`
        : fallback;

    return (
      <div className="commission-details-container">
        <div className="commission-type">
          {option?.commissionTypeName || 'Commission Type'}
        </div>
        <div className="form-inputs">
          <div className="first-input">
            <div className="item">
              <p className="label always-visible">Slab Range</p>
              <Input
                type="text"
                disabled
                value={lowerRange}
                className="slab-range-input"
                readOnly
              />
            </div>
            <div className="item">
              <p className="label always-visible">
                RATE <span className="rate-unit">(p/kg)</span>
              </p>
              <Input
                type="text"
                disabled
                value={leastRate}
                className="rate-input"
                readOnly
              />
            </div>
          </div>
          <div className="second-input">
            <div className="item">
              <Input
                type="text"
                disabled
                value={midRange}
                className="slab-range-input"
                readOnly
              />
            </div>
            <div className="item">
              <Input
                type="text"
                disabled
                value={midRate}
                className="rate-input"
                readOnly
              />
            </div>
          </div>
          <div className="third-input">
            <div className="item">
              <Input
                type="text"
                disabled
                value={upperRange}
                className="slab-range-input"
                readOnly
              />
            </div>
            <div className="item">
              <Input
                type="text"
                disabled
                value={maxRate}
                className="rate-input"
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleSelect = async (option) => {
    if (updatingOptionId !== null || !option) return;

    // Special handling for "Custom" option
    if (option.isCustom) {
      if (type === TRADER_TYPES.BUYER || type === 'BUYER') {
        openDrawerWithTab('INDIAN BUYER COMMISSION');
      } else {
        openDrawerWithTab('INDIAN SELLER COMMISSION');
      }
      return;
    }

    setUpdatingOptionId(option.id);

    try {
      const payload = {
        commissionSlabId: option.id,
        traderId: rowData.id,
        isBuyerCommission: type === TRADER_TYPES.BUYER,
      };

      await axios.put(
        `${process.env.REACT_APP_REST_API_ENDPOINT}commission/update-commission-type-of-trader`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${auth.data.token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      setSelectedType(option.commissionTypeName);
    } catch (error) {
      console.error('Error assigning commission slab:', error);

      // Revert to previous selection if error occurs
      if (type === TRADER_TYPES.BUYER && rowData.buyerCommissionSlab) {
        const previousOption = commissionData?.data?.find(
          (opt) => opt.id === rowData.buyerCommissionSlab.id,
        );
        if (previousOption) {
          setSelectedType(previousOption.commissionTypeName);
        }
      } else if (type !== TRADER_TYPES.BUYER && rowData.sellerCommissionSlab) {
        const previousOption = commissionData?.data?.find(
          (opt) => opt.id === rowData.sellerCommissionSlab.id,
        );
        if (previousOption) {
          setSelectedType(previousOption.commissionTypeName);
        }
      }
    } finally {
      setUpdatingOptionId(null);
      toggleMenu(false);
      setIsOpen(false);
    }
  };

  const buildMenu = (items = []) => {
    if (!items.length) {
      return <MenuItem disabled>No commission types available</MenuItem>;
    }

    return items.map((item) => {
      const isSelected = selectedType === item.commissionTypeName;
      const isCustom = item.commissionTypeName === 'Custom';

      if (isCustom) {
        return (
          <MenuItem
            key={item.id}
            onClick={() => handleSelect(item)}
            className={`menu-item ${isSelected ? 'selected-item' : ''}`}
          >
            <div className="custom-option">
              <BsPlus />
              <p>Custom</p>
            </div>
          </MenuItem>
        );
      }

      return (
        <SubMenu
          key={item.id}
          label={
            <button
              type="button"
              style={{
                width: '100%',
                textAlign: 'left',
                background: 'none',
                border: 'none',
                outline: 'none',
              }}
              onClick={() => handleSelect(item)}
              className={`submenu-wrapper ${isSelected ? 'selected-submenu' : ''}`}
            >
              {item.commissionTypeName?.toLowerCase().includes('global commission')
                ? 'Default'
                : item.commissionTypeName}
            </button>
          }
          onClick={() => handleSelect(item)}
          className={`submenu-wrapper ${isSelected ? 'selected-submenu' : ''}`}
        >
          <MenuItem disabled className="details-menu-item">
            {renderCommissionDetails(item)}
          </MenuItem>
        </SubMenu>
      );
    });
  };

  // Prepare menu items
  const menuItems = [...(commissionData?.data || [])];

  // Add Custom option if not present
  if (menuItems.every((item) => item.commissionTypeName !== 'Custom')) {
    menuItems.push({ id: -1, commissionTypeName: 'Custom', isCustom: true });
  }

  // Add Default option for Global Commission if needed
  if (
    rowData?.isGlobal &&
    !menuItems.some((item) => item.commissionTypeName === 'Default')
  ) {
    menuItems.unshift({ id: 0, commissionTypeName: 'Default' });
  }

  return (
    <div
      className={`commission-selector-container ${isOpen ? 'dropdown-open' : ''} ${updatingOptionId === null ? '' : 'updating'}`}
      id={id}
    >
      <Menu
        {...menuState}
        menuButton={
          <MenuButton
            className={`commission-dropdown-button ${updatingOptionId === null ? '' : 'disabled'}`}
          >
            <div className="dropdown-title-container">
              {updatingOptionId === null ? (
                <span>
                  {selectedType?.toLowerCase().includes('global commission')
                    ? 'Default'
                    : selectedType}
                </span>
              ) : (
                <div className="dropdown-title-updating">
                  <Spinner
                    size="sm"
                    color="primary"
                    className="title-spinner"
                  />
                  {selectedType?.toLowerCase().includes('global commission')
                    ? 'Default'
                    : selectedType}
                </div>
              )}
              {isOpen ? (
                <BsChevronUp className="title-chevron-icon" />
              ) : (
                <BsChevronDown className="title-chevron-icon" />
              )}
            </div>
          </MenuButton>
        }
        onMenuChange={(e) => setIsOpen(e.open)}
        direction="bottom"
        align="end"
        position={isMobileView ? 'anchor' : 'auto'}
        overflow={isMobileView ? 'auto' : 'visible'}
        viewScroll={isMobileView ? 'auto' : 'initial'}
        portal={isMobileView}
        transition
        menuClassName="commission-dropdown-menu"
        disabled={updatingOptionId !== null}
      >
        {buildMenu(menuItems)}
      </Menu>
    </div>
  );
};

CommissionTypeSelector.propTypes = {
  id: PropTypes.string.isRequired,
  rowData: PropTypes.object,
  type: PropTypes.string,
};

export default CommissionTypeSelector;
